export const formatAddress = (walletAddress = '') =>
  walletAddress?.slice(0, 5) + '...' + walletAddress?.slice(-5);
